import { useCallback } from "react";
import { ToolIcon } from "@theorgchartdev/storybook";
import { ProfileBaseballCard } from "@/appComponents/Blocks/Cards/ProfileBaseballCard/ProfileBaseballCard";
import { useNavigationContext } from "@/providers/NavigationProvider";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";
import { enumFeaturesList } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";
import { getFeatureAccess } from "@/Utils/Misc";

// The profile card opened via LaunchUIElement("profile"), e.g. from the box click toolbar.
export const ProfileCardHost = () => {
  const { showProfileCard, LaunchUIElement } = useNavigationContext();
  const { canAccessProfileCard } = usePermissionCheck();
  const onCloseProfile = useCallback(() => LaunchUIElement("profile", false), [LaunchUIElement]);

  if (!canAccessProfileCard) return null;

  return (
    <ProfileBaseballCard
      show={showProfileCard.show}
      target={showProfileCard.target}
      parentReference={null}
      ignoreSelection={showProfileCard.ignoreSelection}
      onClose={onCloseProfile}
    />
  );
};

const ProfileToolbarAction = () => {
  const { LaunchUIElement } = useNavigationContext();
  const { canAccessProfileCard } = usePermissionCheck();

  if (!canAccessProfileCard) return null;

  return (
    <div>
      <ToolIcon
        name={"address-card"}
        title={"Profile"}
        onClick={() => LaunchUIElement("profile", true)}
        tooltipProps={{ message: appstr("Profile") }}
        id="mtb-profile-btn"
        disabled={!getFeatureAccess(enumFeaturesList.profile)}
        data-testid="chart-mode-toolbar-profile"
      />
      <ProfileCardHost />
    </div>
  );
};

export default ProfileToolbarAction;
